//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceSummaryDisplayItem } from './AttendanceSummaryDisplayItem';
import { BillingProfileDisplayItem } from './BillingProfileDisplayItem';
import { EmailInformationDisplayItem } from './EmailInformationDisplayItem';
import { FamilyDisplayItem } from './FamilyDisplayItem';
import { TagDisplayItem } from './TagDisplayItem';
import { TelephoneInformationDisplayItem } from './TelephoneInformationDisplayItem';
import { StudentStatus, LoginAccessStatus } from './Enums';

export class StudentDisplayItem extends ItemBase {
    Active: boolean = false;
    AdultStudentParentID: string | null = null;
    AttendanceSummary: AttendanceSummaryDisplayItem | null = null;
    BillingProfiles: BillingProfileDisplayItem[] = [];
    CanRegisterCancelEvent: boolean = false;
    DateOfBirth: string | null = null;
    DateStarted: string | null = null;
    Email: EmailInformationDisplayItem | null = null;
    HasEmailAddress: boolean = false;
    FaceTimeID: string | null = null;
    Family: FamilyDisplayItem | null = null;
    FamilyID: string | null = null;
    FirstName: string | null = null;
    FullName: string | null = null;
    Gender: string | null = null;
    HasProfilePicture: boolean = false;
    ID: string | null = null;
    LastEventDate: string | null = null;
    LastName: string | null = null;
    LocalSchool: string | null = null;
    ProfileHeadshotURL: string | null = null;
    ProfileThumbnailURL: string | null = null;
    ProfilePictureURL: string | null = null;
    NextEventDate: string | null = null;
    Note: string | null = null;
    Referrer: string | null = null;
    SendEmailReminders: boolean = false;
    SendSMSReminders: boolean = false;
    SkillLevel: string | null = null;
    SkypeUsername: string | null = null;
    Status: StudentStatus = StudentStatus.Active;
    StudentGroups: TagDisplayItem[] = [];     // OBSOLETE - Use only for compatibility
    Tags: TagDisplayItem[] = [];
    SubjectTypes: string[] = [];     // OBSOLETE - Use only for compatibility
    Telephone: TelephoneInformationDisplayItem | null = null;
    AccessStatus: LoginAccessStatus | null = null;
    HasMfa: boolean = false;
    ParentAccessStatus: LoginAccessStatus | null = null;
    LastLogin: string | null = null;

    constructor(initializer?: Partial<StudentDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentDisplayItem";
}
